export enum ProblemTypeEnum {
  Cleaning = 'CLEANING',
  Maintenance = 'MAINTENANCE',
  Danification = 'DANIFICATION',
  Review = 'REVIEW',
  Others = 'OTHERS',
}
